import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { exportSubcategoryThunk, getAllSubcategoryThunk, setSubcategoryPage, setSubcategoryRefresh } from '../../../redux/subcategories/getAllSubcategorySlice';
import api from '../../../utils/api';
import { toast } from 'react-toastify';
import MasterHeader from '../../../component/reusable/MasterHeader';
import { exportDataExcel, fomateDate } from '../../../utils/fomateDate';
import SubcategoriesTable from '../../../component/subcategoryComps/SubcategoriesTable';



const Subcategories = () => {

  const [statuss, setStatus] = useState("");
  const [search, setSearch] = useState('')
  const [limit, setLimit] = useState(25)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [sortBy, setSortyBy] = useState('createdAt');
  const [order, setOrder] = useState('asc')

  const { subcategory, loading, error, refresh, exportLoading,page } = useSelector((state) => state.subcategory);
  const subcategories = subcategory?.data
  const totalPages = subcategory?.totalPages
  const totalItems = subcategory?.totalItems
  const itemsPerPage = subcategory?.limit

  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;



  useEffect(() => {
    dispatch(getAllSubcategoryThunk(`?search=${search}&page=${page}&status=${statuss}&limit=${limit}&sortBy=${sortBy}&order=${order}`));
  }, [page, search, statuss, limit, refresh,sortBy,order]);





  const handleFileChange = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      const response = await api.addBulksubCategory(formData);
      if (response.data) {
        console.log(response.data);
        toast.success(response?.data?.data?.message)
        dispatch(setSubcategoryRefresh());
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'Something went wrong')
    }
  };


  const exportData = async () => {
    const data = await dispatch(exportSubcategoryThunk())
    console.log(data?.payload);

    if (data?.payload?.success === true) {
      const subcategoriesdata = data?.payload?.data
      const exportdata = subcategoriesdata?.map((item) => ({
        'name': item?.name || '-',
        'description': item?.description,
        // 'cover_image': item?.cover_image?.map(i => i)?.join(', ') || '-',
        // 'thumbnail_photo': item?.thumbnail?.photo?.map(i => i)?.join(', ') || '-',
        'thumbnail_status': item?.thumbnail?.status,
        'createdAt': fomateDate(item?.createdAt),
        'categoryName': item?.category?.name
      }))
      exportDataExcel(exportdata, "subcategory")
    }
  }

  const handleOpenMenu = (sort) => {
    setSortyBy(sort)
    setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };


  return (
    <div style={{}}>

      <MasterHeader
        index="Subcategories"
        root="Dashboard"
        setStatus={setStatus}
        setSearch={setSearch}
        handleFileChange={handleFileChange}
        onClickadd={() => navigate('/master/addSubCategory')}
        buttonText={'Add Subcategory'}
        exportData={exportData}
        exportLoading={exportLoading}
      />
      {loading ?
        <div>
          Please wait...
        </div>
        :
        <>
          {
            subcategories?.length > 0 ?
              <SubcategoriesTable
                subcategory={subcategories}
                itemsPerPage={itemsPerPage}
                start={start}
                end={end}
                setPage={setSubcategoryPage}
                totalItems={totalItems}
                page={page}
                handleOpenMenu={handleOpenMenu}

              />
              :
              <div>
                No subcategories found
              </div>
          }
        </>
      }
    </div>
  );
};

export default Subcategories;
